import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PhoneNumbersService } from './phone-numbers.service';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { Msisdn } from '../../shared/msisdn/msisdns';
import { Observable } from 'rxjs/Observable';
import { MatDialog, MatSelectChange } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Ng1IpInfoService } from '../../shared/ng1/ng1-ip-info.service';
import { NotificationService } from '../../shared/notification.service';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-phone-numbers',
  templateUrl: './phone-numbers.component.html',
  styleUrls: ['./phone-numbers.component.scss']
})
export class PhoneNumbersComponent implements OnInit {
  @Input() campaignId;
  @Input() numbers;

  @Output() changePhoneNumberList = new EventEmitter();

  public msisdns: Observable<Msisdn[]>;
  public addForm: FormGroup;

  constructor(
    private phoneNumbersService: PhoneNumbersService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private msisdnService: MsisdnService,
    private router: Router,
    private ng1IpInfoService: Ng1IpInfoService,
    private notify: NotificationService
  ) {}

  ngOnInit() {
    this.prepareMsisdnsList();
    this.checkMainPhoneNumbers();
    this.addForm = this.createAddForm();
  }

  onChangePhoneNumbers(selectValue) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: selectValue
            ? 'PHONE_NUMBERS.HIDE_MODAL.HIDE_PHONE_NUMBER_HEADER'
            : 'PHONE_NUMBERS.HIDE_MODAL.SHOW_PHONE_NUMBER_HEADER',
          body: selectValue
            ? 'PHONE_NUMBERS.HIDE_MODAL.HIDE_PHONE_NUMBER_BODY'
            : 'PHONE_NUMBERS.HIDE_MODAL.SHOW_PHONE_NUMBER_BODY'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.numbers.restricted = selectValue;
          this.phoneNumbersService.save(this.campaignId, this.numbers).subscribe(() => {
            this.refreshNumbers();
          });
        } else {
          this.numbers.restricted = !selectValue;
        }
      });
  }

  prepareMsisdnsList(): any {
    this.msisdns = this.msisdnService
      .msisdns()
      .pipe(
        map((msisdns: any) =>
          msisdns.filter(
            msisdn => !this.numbers.campaignsMsisdns.find(campaignsMsisdn => campaignsMsisdn.id === msisdn.id)
          )
        )
      );
  }

  refreshNumbers() {
    this.msisdnService.projectNumbers(this.campaignId).subscribe((numbers: any) => {
      this.numbers = numbers;
      this.checkMainPhoneNumbers();
      this.prepareMsisdnsList();
      this.changePhoneNumberList.next(numbers);
    });
  }

  onSelectPhoneNumber(select: MatSelectChange) {
    if (!select.value) {
      return;
    }
    this.phoneNumbersService.addPhoneNumber(this.campaignId, select.value.id).subscribe(() => {
      this.notify.open('PHONE_NUMBERS.MESSAGES.ADD');
      this.addForm.get('msisdnId').setValue(null);
      this.refreshNumbers();
    });
  }

  checkMainPhoneNumbers() {
    this.numbers.campaignsMsisdns = this.numbers.campaignsMsisdns.map(number => {
      return {
        ...number,
        mainPhoneNumber: this.numbers.mainCallerId.id === number.id,
        mainEeaPhoneNumber: this.numbers.eeaCallerId.id === number.id
      };
    });
  }

  onSetMainPhoneNumber(number) {
    this.numbers.mainCallerId = number;
    this.phoneNumbersService.save(this.campaignId, this.numbers).subscribe(() => {
      this.notify.open('PHONE_NUMBERS.MESSAGES.CHANGE_MAIN', {
        number: number.msisdn ? number.msisdn : number.label
      });
      this.refreshNumbers();
    });
  }

  onSetMainEeaPhoneNumber(number) {
    this.numbers.eeaCallerId = number;
    this.phoneNumbersService.save(this.campaignId, this.numbers).subscribe(() => {
      this.notify.open('PHONE_NUMBERS.MESSAGES.CHANGE_EEA', {
        number: number.msisdn ? number.msisdn : number.label
      });
      this.refreshNumbers();
    });
  }

  onRemovePhoneNumber(number) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'PHONE_NUMBERS.MODAL.HEADER',
          body: 'PHONE_NUMBERS.MODAL.BODY'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.phoneNumbersService.removePhoneNumber(this.campaignId, number).subscribe(
            () => {
              this.refreshNumbers();
            },
            error => {
              if (error.error instanceof Array) {
                this.notify.open(error.error[0], {}, this.notify.getDefaultCloseAction());
              }
            }
          );
        }
      });
  }

  createAddForm() {
    return this.fb.group({
      msisdnId: null
    });
  }

  gotoNewNumber() {
    const code = this.ng1IpInfoService.getCountry();
    this.router.navigate(['get-new-number', 'pricing', code]);
  }
}
